export const shuttleSelections = (from, to, selected) => {
    const entries = selected.entries();
    for (const [entry] of entries) {
        to.push(from.splice(entry, 1, null)[0]);
    }
    return from.filter(Boolean);
};
export const move = (state, action = {}) => {
    if (action.type === 'MOVE_SELECTIONS') {
        if (!action.from || !action.to) {
            throw new Error(`Missing required actions: from: 'source' | 'target', to: 'source' | 'target'`);
        }
        state[action.from] = shuttleSelections(state[action.from], state[action.to], state.selected[action.from]);
        state.selected[action.from].clear();
        return { ...state };
    }
    return { ...state };
};
